import styled from 'styled-components';
import Panel from 'react-bootstrap/lib/Panel';
import ds from 'designsystem';

const StyledPanelTitle = styled(Panel.Title)`
    margin-bottom: ${ds.get('metrics.s')};
    & a {
        font-size: ${ds.fs('base')};
        color: ${ds.brand('text')};
        font-family: ${ds.get('type.fontFamily.headline')};
        font-weight: ${ds.get('type.fontWeight.bold')};
        text-decoration: none;
    }

`;

export default StyledPanelTitle;



// WEBPACK FOOTER //
// ./src/blocks/PanelGroup/StyledPanelTitle.jsx